module.exports = __webpack_public_path__ + "static/media/pranav1.c92a2724.png";